// Selectors/cacheSelectors.js
import { createSelector } from '@reduxjs/toolkit';

// Basic selectors
export const selectCacheState = (state) => state.cache;

export const selectCacheData = (state) => state.cache.data;

export const selectCacheTimestamps = (state) => state.cache.timestamps;

export const selectCacheLoading = (state) => state.cache.loading;

export const selectCacheError = (state) => state.cache.error;

// Memoized selector for specific cache key
export const makeSelectCachedData = (key) => 
  createSelector(
    [selectCacheData],
    (data) => data[key] || []
  );

// Memoized selector for cache validity check
export const makeSelectIsCacheValid = (key, durationMinutes) => 
  createSelector(
    [selectCacheTimestamps],
    (timestamps) => {
      const cacheTime = timestamps[key];
      if (!cacheTime) return false;
      const age = (Date.now() - cacheTime) / (1000 * 60);
      return age < durationMinutes;
    }
  );

// Comprehensive selector for a cached resource (combines data, loading, error)
export const makeSelectCachedResource = (key) =>
  createSelector(
    [selectCacheState, makeSelectCachedData(key)],
    (cache, cachedData) => ({
      data: cachedData,
      loading: cache.loading,
      error: cache.error,
      timestamp: cache.timestamps[key]
    })
  );

// Selector for your specific CategoryList use case
export const selectTopClasses = createSelector(
  [selectCacheState],
  (cache) => ({
    data: cache.data['topClassesCache'] || [],
    loading: cache.loading,
    error: cache.error
  })
);